import React from 'react';

export enum ReviewStatus {
  actionRequired = 'actionRequired',
  passed = 'passed',
  readyForReview = 'readyForReview',
  uploading = 'uploading',
}

export type UploadDocumentsTilesProps = {
  pagesLimit: number;
};

export type UploadDocumentStateLabelProps = {
  handleDelete?: () => void;
  handleOnClick?: () => void;
  hasImage?: boolean;
  invalidReason?: React.ReactNode;
  isBlurred: boolean;
  isImageLoading?: boolean;
  needsAction?: boolean;
  pageNumberAndLabel?: React.ReactNode;
  reviewStatus: keyof typeof ReviewStatus;
}

export type SetProcessedDocumentParams = {
  [key: string]: boolean;
};

export type PhotoOverlayProps = {
  handleOverlayClick: () => void;
  reviewStatus: keyof typeof ReviewStatus;
}

export type UploadDocumentSectionProps = {
  exitPath: string;
}
